<template>
  <div>
    <div class="h2">
      Vous
    </div>

    <!-- Civilité -->
    <input-radio
      label="Civilité"
      slug="civilite"
      :model="civilite"
      :options="[{'label': 'Mme', 'value': 'mme'}, {'label': 'Mr', 'value': 'm'}]"
      :v$="v$"
      @input="$emit('update:civilite', $event.target.value)"
    />

    <!-- Nom -->
    <input-text
      label="Nom"
      slug="nom"
      :model="nom"
      :v$="v$"
      @input="$emit('update:nom', $event.target.value)"
    />

    <!-- Prénom -->
    <input-text
      label="Prénom"
      slug="prenom"
      :model="prenom"
      :v$="v$"
      @input="$emit('update:prenom', $event.target.value)"
    />

    <!-- Date de naissance -->
    <input-text-date
      label="Date de naissance"
      slug="dateDeNaissance"
      :model="dateDeNaissance"
      :v$="v$"
      @input="$emit('update:dateDeNaissance', $event.target.value)"
    />

    <!-- Régime / Activité / Profession -->
    <regime-select-form
      :regimes="regimes"
      :regime="regime"
      :activite="activite"
      :profession="profession"
      :madelin="madelin"
      :display-madelin="displayMadelin"
      :server-errors="serverErrors"
      regime-slug="regime"
      activite-slug="activite"
      profession-slug="profession"
      madelin-slug="madelin"
      @update-regime="$emit('update:regime', $event)"
      @update-activite="$emit('update:activite', $event)"
      @update-profession="$emit('update:profession', $event)"
      @update-madelin="$emit('update:madelin', $event)"
    />
  </div>
</template>

<script>

import RegimeSelectForm from "src/modules/shared/components/Form/RegimeSelectForm";
import useVuelidate from '@vuelidate/core'
import {required, serverError} from "src/modules/shared/validators/validators";
import {computed } from "vue";
import InputText from "src/modules/shared/components/Form/InputText";
import InputRadio from "src/modules/shared/components/Form/InputRadio";
import InputTextDate from "src/modules/shared/components/Form/InputTextDate";
import dayjs from "dayjs";

export default {
  name: "PersonalInformationForm",
  components: {
    InputText,
    InputTextDate,
    InputRadio,
    RegimeSelectForm
  },
  props: {
    regimes: {
      type: Object,
      default: () => {}
    },
    serverErrors: {
      type: Array,
      required: true
    },
    civilite: {
      type: String,
      default: ''
    },
    nom: {
      type: String,
      default: ''
    },
    prenom: {
      type: String,
      default: ''
    },
    dateDeNaissance: {
      type: String,
      default: ''
    },
    regime: {
      type: String,
      default: ''
    },
    activite: {
      type: String,
      default: ''
    },
    profession: {
      type: String,
      default: ''
    },
    madelin: {
      type: String,
      default: ''
    },
    displayMadelin: {
      type: String,
      default: ''
    }
  },
  emits: [
    'update:civilite',
    'update:nom',
    'update:prenom',
    'update:dateDeNaissance',
    'update:regime',
    'update:activite',
    'update:profession',
    'update:madelin'
  ],
  setup (props) {
    const validations = computed(() => ({
      civilite: {
        required,
        serverError: serverError(props, 'civilite')
      },
      nom: {
        required,
        serverError: serverError(props, 'nom')
      },
      prenom: {
        required,
        serverError: serverError(props, 'prenom')
      },
      dateDeNaissance: {
        required,
        serverError: serverError(props, 'dateDeNaissance')
      }
    }))

    const birthdayToDate = dayjs().subtract(18, 'years').format('DD/MM/YYYY')
    const birthdayFromDate = dayjs().subtract(120, 'years').format('DD/MM/YYYY')

    const v$ = useVuelidate(validations, props)

    return { v$, birthdayToDate, birthdayFromDate }
  },
  watch: {
    serverErrors () {
      this.v$.$reset()
      this.v$.$touch()
    }
  },
}
</script>

<style scoped>

</style>
